import { render, staticRenderFns } from "./HeaderActions.vue?vue&type=template&id=56a80c8a"
import script from "./HeaderActions.vue?vue&type=script&lang=js"
export * from "./HeaderActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports